import type { PointsSummary } from '@/types';

export const formatPointsCount = (points: number): string => {
  return String(Number.isFinite(points) ? Math.trunc(points) : 0);
};

export const buildPointsDisplay = (summary: PointsSummary | null): string => {
  return summary ? formatPointsCount(summary.available_points) : '--';
};

interface PointsTitleParams {
  summary: PointsSummary | null;
  error: string | null;
  loading: boolean;
}

export const buildPointsTitle = ({ summary, error, loading }: PointsTitleParams): string => {
  if (error) {
    return `积分查询失败：${error}。点击重试`;
  }
  if (summary) {
    return `可用积分 ${summary.available_points}，累计获得 ${summary.total_points}，已用 ${summary.used_points}。点击查看积分中心`;
  }
  return loading ? '积分查询中' : '查询积分';
};
